import styled from 'styled-components';

export const StyledCheckbox = styled.div`
  margin-bottom: 12px;
`;

export const Label = styled.label`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: ${props => (props.size === 'l' ? '35px' : '27px')};
  line-height: 19px;
  padding-top: ${props => (props.size === 'l' ? '3px' : '')};
  font-size: ${props => (props.size === 'l' ? '16px' : '14px')};
  color: ${props =>
    props.type === 'primary' ? 'var(--carbone80)' : 'var(--carbone100)'};
`;

export const Text = styled.span`
  width: ${props => (props.size === 'l' ? '24px' : '16px')};
  height: ${props => (props.size === 'l' ? '24px' : '16px')};
  position: absolute;
  top: 2px;
  left: 0;
  border-radius: 4px;
  border: 1px solid var(--aluminium75);

  &:after {
    position: absolute;
    left: ${props => (props.size === 'l' ? '10px' : '8px')};
    top: ${props => (props.size === 'l' ? '5px' : '4px')};
  }
`;

export const Input = styled.input`
  opacity: 0;
  position: absolute;

  &:checked ~ ${Text} {
    background: ${props =>
      props.controlType === 'primary'
        ? 'var(--theme-palette-brand-color,--primary)'
        : 'var(--blue75)'};
    border: 1px solid transparent;

    &:after {
      border-width: 0;
      border: solid
        ${props =>
          props.controlType === 'primary'
            ? 'var(--theme-palette-text,--carbone100)'
            : 'var(--white)'};
      border-width: 0 1.5px 1.5px 0;
      opacity: 1;

      left: 5px;
      top: 3px;
    }
  }

  & + ${Text}:after {
    content: '';
    width: 4px;
    height: 8px;
    border: 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: opacity 0.25s ease;
  }
`;
